var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { key: _vm.key, staticClass: "form-body" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-9" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "nom" } }, [_vm._v("Nom")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.planAlimentaire.nom,
                expression: "planAlimentaire.nom"
              }
            ],
            staticClass: "form-control",
            attrs: { id: "nom", type: "text", maxlength: "80" },
            domProps: { value: _vm.planAlimentaire.nom },
            on: {
              focus: function($event) {
                return $event.target.select()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.planAlimentaire, "nom", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "col-3" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", [_vm._v("Période")]),
            _c("b-form-select", {
              attrs: { options: _vm.optionsPeriodes },
              model: {
                value: _vm.planAlimentaire.periodeId,
                callback: function($$v) {
                  _vm.$set(_vm.planAlimentaire, "periodeId", $$v)
                },
                expression: "planAlimentaire.periodeId"
              }
            })
          ],
          1
        )
      ])
    ]),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", [_vm._v("Convives impactés")]),
            _c("MultiSelect", {
              attrs: {
                value: _vm.planAlimentaire.typesConvivesIds,
                items: _vm.optionsConvives,
                placeholder: "Convives...",
                emptyText: "Tous les convives ont été ajoutés"
              },
              on: {
                change: function($event) {
                  _vm.planAlimentaire.typesConvivesIds = $event
                }
              }
            })
          ],
          1
        )
      ])
    ]),
    _c("div", { staticClass: "push-top-1rem" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { ref: "effectifs", staticClass: "col-12" },
          _vm._l(_vm.planAlimentaire.services, function(service, iService) {
            return _c(
              "div",
              { key: iService, attrs: { id: "accordion" + iService } },
              [
                _c("div", { staticClass: "card no-margin-bottom" }, [
                  _c(
                    "div",
                    {
                      staticClass: "card-header cursor-pointer",
                      attrs: {
                        id: "headingOne" + iService,
                        "data-toggle": "collapse",
                        "data-target": "#collapseOne" + iService,
                        "aria-expanded": "true",
                        "aria-controls": "collapseOne" + iService
                      }
                    },
                    [_c("h5", [_vm._v(" " + _vm._s(service.nom) + " ")])]
                  ),
                  _c(
                    "div",
                    {
                      class: service.composantes.length
                        ? "collapse.show"
                        : "collapse",
                      attrs: {
                        id: "collapseOne" + iService,
                        "aria-labelledby": "headingOne" + iService,
                        "data-parent": "#accordion" + iService
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "card-body" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btn-sm btn-secondary",
                              on: {
                                click: function($event) {
                                  return _vm.ajoutComposante(service)
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fas fa-plus" }),
                              _vm._v(" composante")
                            ]
                          ),
                          _c(
                            "table",
                            {
                              staticClass: "table",
                              staticStyle: {
                                "table-layout": "fixed",
                                "word-wrap": "break-word"
                              }
                            },
                            [
                              _vm._m(0, true),
                              _c(
                                "tbody",
                                _vm._l(service.composantes, function(
                                  composante,
                                  iComposante
                                ) {
                                  return _c(
                                    "tr",
                                    {
                                      key: iComposante,
                                      staticClass: "ligne-composante-titre"
                                    },
                                    [
                                      _c("td", [
                                        _c("div", [
                                          _vm._v(_vm._s(composante.nom))
                                        ])
                                      ]),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "flex-center-space-between cursor-pointer"
                                        },
                                        [
                                          _c("div", {
                                            staticStyle: { width: "15px" }
                                          }),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName: "v-tooltip",
                                                  value: {
                                                    content:
                                                      "Supprimer la composante",
                                                    placement: "top"
                                                  },
                                                  expression:
                                                    "{content: 'Supprimer la composante', placement: 'top'}"
                                                }
                                              ],
                                              on: {
                                                click: function($event) {
                                                  return _vm.effacerComposante(
                                                    service,
                                                    composante
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-times"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ])
              ]
            )
          }),
          0
        )
      ])
    ]),
    _c(
      "div",
      { staticClass: "form-actions flex-right" },
      [
        _c(
          "b-button",
          {
            staticStyle: { float: "right" },
            attrs: {
              type: "submit",
              disabled: _vm.enregistrementEnCours,
              variant: "success",
              alt: "Enregistrer"
            },
            on: { click: _vm.enregistrerPlan }
          },
          [_vm._v("Enregistrer")]
        ),
        _c(
          "b-button",
          {
            staticStyle: { float: "right", "margin-right": "10px" },
            attrs: { type: "submit", variant: "danger", alt: "Annuler" },
            on: { click: _vm.annulerEdition }
          },
          [_vm._v("Annuler")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col"),
      _c("col", { attrs: { width: "300" } }),
      _c("col", { attrs: { width: "70" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }